import shuffle from 'lodash/shuffle';
import { Training } from '@/interfaces/class/training';

export default (el: Training) => {
  const enFillersShuffled = shuffle(el.enAlternative.split('\n'));
  const partResults : {
    [key: string]: {
      text: string;
    };
  } = {};

  enFillersShuffled.forEach((text: string, i: number) => {
    partResults[i] = { text };
  });

  return {
    ...el,
    partResults,
    enFillersCorrect: el.enAlternative.split('\n'),
    enFillersShuffled,
  };
};
